const locale = {
	PROJECTS_PLANNED_VALUE: 'Fatturato previsto: {value}',
	PROJECTS_PLANNED_EXPENSES: 'Costi previsti: {value}',

	DETAILS_PROJECTS_TAB_ACTIVITIES_KANBAN: 'Kanban Attività',

	// #region Projects fields
	DETAILS_PROJECTS_FIELD_TITLE: 'Titolo',
	DETAILS_PROJECTS_FIELD_STATUS: 'Stato Progetto',
	DETAILS_PROJECTS_FIELD_TYPE: 'Tipo Progetto',
	DETAILS_PROJECTS_FIELD_COMPANY: 'Azienda',
	DETAILS_PROJECTS_FIELD_PERSON: 'Referente esterno',
	DETAILS_PROJECTS_FIELD_ASSIGNED_USER: 'Utente assegnato interno',
	DETAILS_PROJECTS_FIELD_ASSIGNED_USER_2: 'Utente assegnato esterno',
	DETAILS_PROJECTS_FIELD_ASSIGNED_GROUP: 'Gruppo assegnato',
	DETAILS_PROJECTS_FIELD_DATE_FROM: 'Data inizio',
	DETAILS_PROJECTS_FIELD_DATE_TO: 'Data fine',
	DETAILS_PROJECTS_FIELD_PROGRESS: 'Progresso',
	DETAILS_PROJECTS_FIELD_INTERNALNUMBER: 'Numero interno',
	DETAILS_PROJECTS_FIELD_VALUE_PLANNED: 'Fatturato previsto',
	DETAILS_PROJECTS_FIELD_EXPENSES_PLANNED: 'Costi previsti',
	DETAILS_PROJECTS_FIELD_EXPENSES_OTHER: 'Costi vari',
	DETAILS_PROJECTS_FIELD_LENGTH_HOURS_PLANNED: 'Ore previste',
	DETAILS_PROJECTS_FIELD_LENGTH_HOURS: 'Ore effettive',
	DETAILS_PROJECTS_FIELD_TAGS: 'Tag',
	DETAILS_PROJECTS_FIELD_WARNING: 'Warning',
	DETAILS_PROJECTS_FIELD_BLOCKED: 'Bloccato',
	// #endregion

	// #region Projects general stats section
	PROJ_SECTION_BILLING_STATS_TITLE: 'Statistiche Progetto',

	PROJ_SECTION_BILLING_STATS_VALUE_PLANNED: 'Fatturato previsto',
	PROJ_SECTION_BILLING_STATS_VALUE_FINAL: 'Fatturato attuale',
	PROJ_SECTION_BILLING_STATS_VALUE_MISSING: 'Delta da fatturare',

	PROJ_SECTION_BILLING_STATS_EXPENSES_TOTAL: 'Costo attuale',
	PROJ_SECTION_BILLING_STATS_EXPENSES_INVOICES: 'di cui Prodotti',
	PROJ_SECTION_BILLING_STATS_EXPENSES_WORKREPORTS: 'di cui Servizi',
	PROJ_SECTION_BILLING_STATS_EXPENSES_OTHER: 'di cui altro',

	PROJ_SECTION_BILLING_STATS_PROFIT_PLANNED: 'Margine previsto',
	PROJ_SECTION_BILLING_STATS_PROFIT_FINAL: 'Margine attuale',
	// #endregion

	// #region Projects WorkReports stats section
	PROJ_SECTION_WORKREPORTS_STATS_TITLE: 'Statistiche Rapportini',

	PROJ_SECTION_WORKREPORTS_STATS_COLUMN_TYPE: 'Tipologia',
	PROJ_SECTION_WORKREPORTS_STATS_COLUMN_HOURS_PLANNED: 'Durata prevista',
	PROJ_SECTION_WORKREPORTS_STATS_COLUMN_HOURS: 'Durata effettiva',
	PROJ_SECTION_WORKREPORTS_STATS_COLUMN_VALUE_PLANNED: 'Fatturato previsto',
	PROJ_SECTION_WORKREPORTS_STATS_COLUMN_EXPENSES_PLANNED: 'Costo previsto',
	PROJ_SECTION_WORKREPORTS_STATS_COLUMN_EXPENSES_BILLED: 'Costo attuale',
	PROJ_SECTION_WORKREPORTS_STATS_COLUMN_PROFIT_PLANNED: 'Margine previsto',

	PROJ_SECTION_WORKREPORTS_STATS_NO_TYPE: 'Senza tipo',
	PROJ_SECTION_WORKREPORTS_STATS_TOTAL: 'Totale'
	// #endregion
};

export default locale;
